var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 6.44772 10.4477 6 11 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H11C10.4477 8 10 7.55228 10 7Z",
    fill: "#181C21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 9.44772 10.4477 9 11 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11H11C10.4477 11 10 10.5523 10 10Z",
    fill: "#181C21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C10 12.4477 10.4477 12 11 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H11C10.4477 14 10 13.5523 10 13Z",
    fill: "#181C21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 4.34315 4.34315 3 6 3H7H9H19C20.1046 3 21 3.89543 21 5V20.5172C21 20.6953 20.7846 20.7846 20.6586 20.6586L19.5 19.5L17.5989 20.9258C17.5383 20.9713 17.4572 20.9786 17.3894 20.9447L14.5 19.5L12.0941 20.9435C12.0355 20.9787 11.963 20.9815 11.9018 20.9509L9 19.5L7.32 20.76C7.18815 20.8589 7 20.7648 7 20.6V18.9538L9 17.2038V17.2639L11.9124 18.7202L14.4124 17.2202L17.2889 18.6584L19 17.375V5H9V10V16L7 17.75V10H3V6ZM6 5H7V8H5V6C5 5.44772 5.44772 5 6 5Z",
    fill: "#181C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBill);
export default __webpack_public_path__ + "static/media/icon_bill.879d99b8d5f2daeefc5d72ca0fe50c85.svg";
export { ForwardRef as ReactComponent };